import type { CalloutBlock as Block } from './types'
import { BlockShell } from './BlockShell'
import { TextBlockBase } from './TextBlockBase'
import type { BlockAction } from './BlockActionsMenu'
import { cn } from '@/lib/utils'

interface Props {
  block: Block
  selected: boolean
  frozen: boolean
  animate: boolean
  actions: BlockAction[]
  onTextChange: (id: string, text: string) => void
  onToggleSelect: (id: string) => void
}

const VARIANT_BG: Record<Block['variant'], string> = {
  info: 'bg-blue-50 border-blue-200',
  warning: 'bg-amber-50 border-amber-200',
  success: 'bg-green-50 border-green-200',
}

export function CalloutBlockView({
  block,
  selected,
  frozen,
  animate,
  actions,
  onTextChange,
  onToggleSelect,
}: Props) {
  return (
    <BlockShell
      blockId={block.id}
      slug={block.slug}
      selected={selected}
      frozen={frozen}
      animate={animate}
      actions={actions}
      onToggleSelect={onToggleSelect}
      editable
    >
      <div className={cn('rounded-md border px-3 py-2', VARIANT_BG[block.variant])}>
        <TextBlockBase
          as="p"
          readOnly={frozen}
          value={block.text}
          onChange={(next) => onTextChange(block.id, next)}
          className="text-sm"
        />
      </div>
    </BlockShell>
  )
}
